import type { UiTheme } from "../theme";

// The ONE wrapping-head recipe (#388, #416): a title that keeps its line on
// the left, a cluster on the right that wraps UNDER it when the row is full.
// ChartHead and PanelTitleRow (Progress) both draw it; each merges its own
// local differences (the title's voice, a rowGap, a wrapping cluster).
export function wrappingHeadStyles(theme: UiTheme) {
  const { spacing: s } = theme;
  return {
    row: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      columnGap: s.s2,
    },
    // The name keeps its width; the cluster is what wraps.
    title: { flexGrow: 1, flexShrink: 0, flexBasis: "auto" },
    cluster: {
      flexDirection: "row",
      alignItems: "center",
      columnGap: s.s2,
      flexShrink: 1,
    },
  } as const;
}
